import angular from 'angular';
import uiRouter from 'angular-ui-router';
import OrderAndPayMainComponent from './main.component';

const OrderAndPayMainModule = angular.module('tinaba.components.services.orderAndPay.main', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('services.orderAndPay.main', {
      url: '/main',
      template: '<order-and-pay-main></order-and-pay-main>'
    });
})

.component('orderAndPayMain', OrderAndPayMainComponent);

export default OrderAndPayMainModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/main/main.js
 **/